import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export enum LinkType {
  ROUTER_LINK = "routerLink",
  HREF = "href",
  EMPTY = "empty"
}

@Component({
  selector: "ta-link",
  templateUrl: "./link.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkComponent {
  linkType: LinkType = LinkType.EMPTY;

  @Input()
  get href(): string {
    return this._href;
  }

  set href(value: string) {
    if (this._href === value) {
      return;
    }

    this._href = value;
    this.setLinkType();
  }
  private _href: string;

  @Input()
  get taRouterLink(): any[] | string {
    return this._taRouterLink;
  }

  set taRouterLink(value: any[] | string) {
    if (this._taRouterLink === value) {
      return;
    }

    this._taRouterLink = value;
    this.setLinkType();
  }
  private _taRouterLink: any[] | string;

  @Input()
  fragment?: string;

  @Input()
  queryParams?: object;

  @Input()
  disabled?: boolean = false;

  @Input()
  target: "_blank" | "_self" | "_parent" | "_top" = "_self";

  private setLinkType(): void {
    if (this.href != null) {
      this.linkType = LinkType.HREF;
    } else if (this.taRouterLink != null) {
      this.linkType = LinkType.ROUTER_LINK;
    } else {
      this.linkType = LinkType.EMPTY;
    }
  }
}
